module.exports = __webpack_public_path__ + "img/log_light_3.27df815f.png";